import { DateTime } from 'luxon';

export default function formatMessageDatetime(datetimeStr: string) {
  const datetime = DateTime.fromISO(datetimeStr);

  if (datetime.hasSame(DateTime.local(), 'day')) {
    return `${datetime.toFormat('h:mm a')}`;
  }

  if (datetime.hasSame(DateTime.local().minus({ days: 1 }), 'day')) {
    return `Yesterday at ${datetime.toFormat('h:mm a')}`;
  }

  return datetime.toFormat('M/d/yyyy h:mm a');
}
